import * as actionTypes from "../actionTypes/Index";

import { IActionType } from "../../interfaces/Index";
import { warehouseOpsInitialState } from "./InitialState";

const initialState = { ...warehouseOpsInitialState };

export default function warehouseOpsReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.START_WAREHOUSE_SHIFT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isWarehouseShiftStarted: false,
        warehouseShiftId: null,
      });
    }
    case actionTypes.START_WAREHOUSE_SHIFT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isWarehouseShiftStarted: true,
        warehouseShiftId: action.payload,
      });
    }
    case actionTypes.START_WAREHOUSE_SHIFT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.END_WAREHOUSE_SHIFT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isShiftEnded: false,
      });
    }
    case actionTypes.END_WAREHOUSE_SHIFT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isShiftEnded: true,
        warehouseShiftId: null,
        isWarehouseShiftStarted: false,
      });
    }
    case actionTypes.END_WAREHOUSE_SHIFT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isTourAdded: false,
        isTourCsvUploaded: false,
      });
    }
    case actionTypes.UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isTourAdded: true,
        isTourCsvUploaded: true,
      });
    }
    case actionTypes.UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
